module.exports = __webpack_public_path__ + "static/media/spare.391bee5e.svg";